import { createResourceBooking } from "../../../utils/axios-requests";
import type { BookingStrategyContext } from "./bookingStrategies";

function resourceBookingStartEnd(
  startDate: string | null,
  endDate: string | null,
  startTime: string | null,
  endTime: string | null
): { start: string; end: string } {
  const start = startDate && startTime ? `${startDate}T${startTime}` : "";
  const end = endDate && endTime ? `${endDate}T${endTime}` : "";
  return { start, end };
}

export const resourceBookingStrategy = (ctx: BookingStrategyContext) => {
  const resource = ctx.inputs.bookedResource;
  const resourceKind = ctx.inputs.resourceKind ?? resource?.resourceKind;
  const locationInventoryId = ctx.inputs.selectedLocation ?? 0;
  const serviceId = resource?.id ?? 0;
  const orderedQty = resourceKind === "equipment" ? 1 : Math.max(1, ctx.inputs.orderedQty ?? 1);

  const { startDate, endDate, startTime, endTime } = ctx.standardBookingTimes;
  const { start, end } = resourceBookingStartEnd(startDate, endDate, startTime, endTime);

  const post = () =>
    createResourceBooking({
      locationInventoryId,
      resourceKind: resourceKind ?? "equipment",
      serviceId,
      start,
      end,
      orderedQty
    });

  post()
    .then(() => {
      ctx.onSuccess();
    })
    .catch(ctx.onError);
};
